import PropTypes from 'prop-types'
import { useRef, useState } from 'react'

import { Box, Typography, Link } from '@mui/material'
import UploadFileIcon from '@mui/icons-material/UploadFile'

const UploadBox = ({ setFile }) => {

    const inputRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)

    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(false)

        const files = e.dataTransfer?.files
        if (!files || files.length === 0) return

        setFile(files[0])
    }

    return (
        <Box
            onClick={() => inputRef.current?.click()}
            onDragEnter={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsDragging(true)
            }}
            onDragOver={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsDragging(true)
            }}
            onDragLeave={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsDragging(false)
            }}
            onDrop={handleDrop}
            mt={2}
            sx={{
                border: '2px dashed',
                borderColor: isDragging ? 'primary.main' : 'grey.400',
                borderRadius: 2,
                py: 6,
                px: 2,
                textAlign: 'center',
                cursor: 'pointer',
                transition: '0.2s ease',
                bgcolor: isDragging ? 'action.hover' : 'background.paper',
                filter: isDragging ? 'brightness(0.95)' : 'none',
            }}
        >
            <Typography fontSize={40} color='primary'>
                <UploadFileIcon fontSize='large' />
            </Typography>

            <Typography>
                {isDragging ? 'Solte o arquivo aqui' : 'Arraste e solte o arquivo'}
            </Typography>

            <Typography>
                ou{' '}
                <Link
                    component='button'
                    onClick={(e) => {
                        e.stopPropagation()
                        inputRef.current?.click()
                    }}
                >
                    selecione aqui
                </Link>
            </Typography>

            <Typography variant='caption' color='text.secondary'>
                CSV (max. 5GB)
            </Typography>

            <input
                ref={inputRef}
                type='file'
                hidden
                accept='.csv,text/csv'
                onChange={(e) => {
                    const f = e.target.files?.[0]
                    if (f) setFile(f)
                    e.target.value = ''
                }}
            />
        </Box>
    )
}

UploadBox.propTypes = {
    setFile: PropTypes.func.isRequired
}

export default UploadBox
